module.exports = __webpack_public_path__ + "img/relationship-worries.398211ff.svg";